import { cn } from "@/lib/utils";

// Shared styled tooltip for all Recharts charts
export const ChartTooltip = ({ active, payload, label, formatter, labelFormatter }) => {
    if (!active || !payload || !payload.length) return null;
    return (
        <div className="rounded-lg border border-border/70 bg-popover/95 px-3 py-2 shadow-lift backdrop-blur">
            {label !== undefined && (
                <p className="mb-1 text-xs font-semibold text-foreground">
                    {labelFormatter ? labelFormatter(label) : label}
                </p>
            )}
            <div className="space-y-1">
                {payload.map((entry, i) => {
                    const val = formatter ? formatter(entry.value, entry) : entry.value;
                    return (
                        <div key={i} className="flex items-center gap-2 text-xs">
                            <span
                                className="h-2.5 w-2.5 shrink-0 rounded-[3px]"
                                style={{ background: entry.color || entry.fill }}
                            />
                            <span className="text-muted-foreground">{entry.name}</span>
                            <span className="ml-auto font-semibold tabular text-foreground">{val}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export const axisProps = {
    tick: { fill: "hsl(var(--muted-foreground))", fontSize: 12 },
    tickLine: false,
    axisLine: { stroke: "hsl(var(--border))" },
};

export const gridProps = {
    strokeDasharray: "3 3",
    stroke: "hsl(var(--border))",
    vertical: false,
};

export { cn };
